import UserStore from '../../../../stores/UserStore';
import { createSelector } from 'reselect';

const containers = (state) => state.containers.list;
const locales = (state) => state.containers.locales;

export const getContainers = createSelector(
    containers,
    (containers = []) => {
        return containers;
    }
);

export const getHeaderNames = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().dataTable.headers;
        return [
            '№',
            null,
            staticNames.name,
            staticNames.link
        ];
    }
);

export const getLocales = createSelector(
    locales,
    (locales = []) => {
        return locales;
    }
);
